import { useSelector } from "react-redux";
import EmployeeEditComponents from "../components/EmployeeEdit";
import useEmployeeEdit from "../hooks/useEmployeeEdit";
import { Skeleton } from "antd";

function EmployeeEdit() {
  const employeeEditProps = useEmployeeEdit();
  return <EmployeeEditComponents {...employeeEditProps} />;
}

export default EmployeeEdit;
